export interface HolidayTypeDetailClass {
    AccountHolidayTypeDetailId: string
    AccountHolidayTypeId: string
    MasterHolidayTypeDetailId: string
    HolidayName: string
    HolidayDate:string
    AccountId: number
    BreakType: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number   
    isSelected: number
}

export const holidayTypeDetailInitialsForAdd = {
    HolidayName: "",
    AccountHolidayTypeId: 0,
    HolidayDate: new Date()

}

export const holidayTypeDetailnitialsForUpdate = {
    HolidayName: "",
    AccountHolidayTypeDetailId: "",
    AccountHolidayTypeId: "",
    HolidayDate: new Date()
}